module.exports = __webpack_public_path__ + "img/9788959523979.1b5b035e.jpg";